import axios from 'axios';
import _ from 'lodash';
import { UPDATE_USER_SHIPPING_INFO, UPDATE_TAX_DISPLAY } from './types';

const updateTaxDisplay = taxUpdate => {
  return {
    type: UPDATE_TAX_DISPLAY,
    payload: { taxUpdate },
  };
};

const updateUserObject = payload => {
  return {
    type: UPDATE_USER_SHIPPING_INFO,
    payload,
  };
};

const updateUserShippingInfo = newAddress => {
  return (dispatch, getState) => {
    dispatch(updateUserObject(newAddress));
    const { userInfo } = getState();
    const postBody = {
      customer: userInfo.customer,
      productChildGuid: userInfo.product.guid,
      quantity: userInfo.product.quantity,
      shippingMethodCode: userInfo.product.defaultShippingMethodCode,
      patientGuid: userInfo.prescription.patientGuid,
      flavorCode: userInfo.product.flavorCode,
      prescriptionGuid: userInfo.prescription.prescriptionGuid,
      billingType: userInfo.billingType,
      shipToType: userInfo.shipToType,
    };
    return axios
      .post(`${APIENDPOINT}/taxes`, postBody, {
        headers: { bearer: userInfo.authentication.replace('Bearer: ', '') },
      })
      .then(
        response => {
          if (!_.isEmpty(response.data)) {
            dispatch(updateTaxDisplay(response.data));
          }
        },
        error => {
          /* [apk] todo: let's pick an error behavior */
          console.log(error.response);
        }
      );
  };
};

export default updateUserShippingInfo;



// WEBPACK FOOTER //
// ./src/actions/userInformation/updateUserShippingInfo.js